import { combineReducers } from 'redux';
import addFulfilmentReducer from './AddFulfilmentReducer';
import childrenListReducer from './ChildrenListReducer';
import navigationReducer from './NavigationReducer';
import sponsorsListReducer from './SponsorsListReducer';
import contactReducer from './ContactReducer';
import notificationReducer from './NotificationReducer';

export default combineReducers({
  childrenListReducer,
  addFulfilmentReducer,
  sponsorsListReducer,
  contactReducer,
  navigationReducer,
  notificationReducer
});



// WEBPACK FOOTER //
// ./src/Reducers/index.js